import React from "react";
import Header from "./Header.jsx";
import SideNav from "./SideNav.jsx";
import styles from "./Layout.module.scss";
import useCommonStore from "../stores/common.js";

const Layout = ({ children }) => {
  const sideNavCollapsed = useCommonStore((state) => state.sideNavCollapsed);

  return (
    <div className={`${styles.main_layout}`}>
      <SideNav />
      <div
        className={`${styles.content_wrapper} ${sideNavCollapsed ? styles.collapsed : ""}`}
      >
        <Header />
        {children}
      </div>
    </div>
  );
};

export default Layout;
